export default [
    {
        c2cId: 'SJC_LAX',
        urlSlug: '/bus/us-ca/san-jose/us-ca/los-angeles',
    },
    {
        c2cId: 'CHI_IND',
        urlSlug: '/bus/us-il/chicago/us-in/indianapolis',
    },
    {
        c2cId: 'BAL_NYC',
        urlSlug: '/train/us-md/baltimore/us-ny/new-york',
    },
    {
        c2cId: 'DCA_BAL',
        urlSlug: '/bus/us-dc/washington/us-md/baltimore',
    },
    {
        c2cId: 'NYC_PGH',
        urlSlug: '/bus/us-ny/new-york/us-pa/pittsburgh',
    },
    {
        c2cId: 'IND_CHI',
        urlSlug: '/train/us-in/indianapolis/us-il/chicago',
    },
    {
        c2cId: 'CHM_CHI',
        urlSlug: '/bus/us-il/champaign/us-il/chicago',
    },
    {
        c2cId: 'NWK_BOS',
        urlSlug: '/bus/us-nj/newark/us-ma/boston',
    },
    {
        c2cId: 'ORL_TPA',
        urlSlug: '/train/us-fl/orlando/us-fl/tampa',
    },
    {
        c2cId: 'ROC_NYC',
        urlSlug: '/bus/us-ny/rochester/us-ny/new-york',
    },
    {
        c2cId: 'ARB_CHI',
        urlSlug: '/train/us-mi/ann-arbor/us-il/chicago',
    },
    {
        c2cId: 'BOS_CAMTL',
        urlSlug: '/bus/us-ma/boston/ca-qc/montreal',
    },
    {
        c2cId: 'HFD_BOS',
        urlSlug: '/bus/us-ct/hartford/us-ma/boston',
    },
    {
        c2cId: 'BOS_PHL',
        urlSlug: '/train/us-ma/boston/us-pa/philadelphia',
    },
    {
        c2cId: 'FLL_ORL',
        urlSlug: '/train/us-fl/fort-lauderdale/us-fl/orlando',
    },
    {
        c2cId: 'PVD_NYC',
        urlSlug: '/train/us-ri/providence/us-ny/new-york',
    },
    {
        c2cId: 'CATOR_CAMTL',
        urlSlug: '/train/ca-on/toronto/ca-qc/montreal',
    },
    {
        c2cId: 'CATOR_CAVAC',
        urlSlug: '/train/ca-on/toronto/ca-bc/vancouver',
    },
    {
        c2cId: 'NYC_NFL',
        urlSlug: '/bus/us-ny/new-york/us-ny/niagara-falls',
    },
    {
        c2cId: 'NYC_HFD',
        urlSlug: '/bus/us-ny/new-york/us-ct/hartford',
    },
    {
        c2cId: 'NYC_BIN',
        urlSlug: '/bus/us-ny/new-york/us-ny/binghamton',
    },
    {
        c2cId: 'GRR_CHI',
        urlSlug: '/bus/us-mi/grand-rapids/us-il/chicago',
    },
    {
        c2cId: 'PHL_NYC',
        urlSlug: '/bus/us-pa/philadelphia/us-ny/new-york',
    },
    {
        c2cId: 'NYC_NFL',
        urlSlug: '/train/us-ny/new-york/us-ny/niagara-falls',
    },
    {
        c2cId: 'CATOR_CANFS',
        urlSlug: '/train/ca-on/toronto/ca-on/niagara-falls',
    },
    {
        c2cId: 'CATOR_CAMTL',
        urlSlug: '/bus/ca-on/toronto/ca-qc/montreal',
    },
    {
        c2cId: 'CAVAC_SEA',
        urlSlug: '/train/ca-bc/vancouver/us-wa/seattle',
    },
    {
        c2cId: 'MIA_NYC',
        urlSlug: '/bus/us-fl/miami/us-ny/new-york',
    },
    {
        c2cId: 'PHL_BOS',
        urlSlug: '/bus/us-pa/philadelphia/us-ma/boston',
    },
    {
        c2cId: 'SEA_CAVAC',
        urlSlug: '/bus/us-wa/seattle/ca-bc/vancouver',
    },
    {
        c2cId: 'NYC_BNY',
        urlSlug: '/bus/us-ny/new-york/us-ny/buffalo',
    },
    {
        c2cId: 'CAVAC_CATOR',
        urlSlug: '/bus/ca-bc/vancouver/ca-on/toronto',
    },
    {
        c2cId: 'ORL_NYC',
        urlSlug: '/bus/us-fl/orlando/us-ny/new-york',
    },
    {
        c2cId: 'PGH_NYC',
        urlSlug: '/train/us-pa/pittsburgh/us-ny/new-york',
    },
    {
        c2cId: 'STL_CHI',
        urlSlug: '/bus/us-mo/st-louis/us-il/chicago',
    },
    {
        c2cId: 'DET_CHI',
        urlSlug: '/bus/us-mi/detroit/us-il/chicago',
    },
    {
        c2cId: 'CHI_LAX',
        urlSlug: '/bus/us-il/chicago/us-ca/los-angeles',
    },
    {
        c2cId: 'BNY_NYC',
        urlSlug: '/train/us-ny/buffalo/us-ny/new-york',
    },
    {
        c2cId: 'CAVAC_CATOR',
        urlSlug: '/train/ca-bc/vancouver/ca-on/toronto',
    },
    {
        c2cId: 'CHI_DET',
        urlSlug: '/bus/us-il/chicago/us-mi/detroit',
    },
    {
        c2cId: 'DCA_NYC',
        urlSlug: '/train/us-dc/washington/us-ny/new-york',
    },
    {
        c2cId: 'GRR_CHI',
        urlSlug: '/train/us-mi/grand-rapids/us-il/chicago',
    },
    {
        c2cId: 'IND_CHI',
        urlSlug: '/bus/us-in/indianapolis/us-il/chicago',
    },
    {
        c2cId: 'NYC_ORL',
        urlSlug: '/train/us-ny/new-york/us-fl/orlando',
    },
    {
        c2cId: 'NYC_PVD',
        urlSlug: '/train/us-ny/new-york/us-ri/providence',
    },
    {
        c2cId: 'RIC_DCA',
        urlSlug: '/train/us-va/richmond/us-dc/washington',
    },
    {
        c2cId: 'ROC_NYC',
        urlSlug: '/train/us-ny/rochester/us-ny/new-york',
    },
    {
        c2cId: 'SEA_LWA',
        urlSlug: '/train/us-wa/seattle/us-wa/leavenworth',
    },
    {
        c2cId: 'SYR_NYC',
        urlSlug: '/train/us-ny/syracuse/us-ny/new-york',
    },
    {
        c2cId: 'SEA_PDX',
        urlSlug: '/train/us-wa/seattle/us-or/portland',
    },
    {
        c2cId: 'KCY_CHI',
        urlSlug: '/bus/us-mo/kansas-city/us-il/chicago',
    },
    {
        c2cId: 'BOS_CAMTL',
        urlSlug: '/train/us-ma/boston/ca-qc/montreal',
    },
    {
        c2cId: 'CAMTL_NYC',
        urlSlug: '/train/ca-qc/montreal/us-ny/new-york',
    },
    {
        c2cId: 'CHI_DET',
        urlSlug: '/train/us-il/chicago/us-mi/detroit',
    },
    {
        c2cId: 'DCA_RIC',
        urlSlug: '/train/us-dc/washington/us-va/richmond',
    },
    {
        c2cId: 'NYC_MIA',
        urlSlug: '/bus/us-ny/new-york/us-fl/miami',
    },
    {
        c2cId: 'ORL_TPA',
        urlSlug: '/bus/us-fl/orlando/us-fl/tampa',
    },
    {
        c2cId: 'DET_CHI',
        urlSlug: '/train/us-mi/detroit/us-il/chicago',
    },
    {
        c2cId: 'DCA_NYC',
        urlSlug: '/bus/us-dc/washington/us-ny/new-york',
    },
    {
        c2cId: 'LAX_NYC',
        urlSlug: '/train/us-ca/los-angeles/us-ny/new-york',
    },
    {
        c2cId: 'PVD_NYC',
        urlSlug: '/bus/us-ri/providence/us-ny/new-york',
    },
    {
        c2cId: 'NWK_DCA',
        urlSlug: '/bus/us-nj/newark/us-dc/washington',
    },
    {
        c2cId: 'NYC_MIA',
        urlSlug: '/train/us-ny/new-york/us-fl/miami',
    },
    {
        c2cId: 'PHL_BOS',
        urlSlug: '/train/us-pa/philadelphia/us-ma/boston',
    },
    {
        c2cId: 'SFO_LAX',
        urlSlug: '/train/us-ca/san-francisco/us-ca/los-angeles',
    },
    {
        c2cId: 'BOS_DCA',
        urlSlug: '/bus/us-ma/boston/us-dc/washington',
    },
    {
        c2cId: 'CAVAC_SEA',
        urlSlug: '/bus/ca-bc/vancouver/us-wa/seattle',
    },
    {
        c2cId: 'CHI_NYC',
        urlSlug: '/train/us-il/chicago/us-ny/new-york',
    },
    {
        c2cId: 'NHV_NYC',
        urlSlug: '/bus/us-ct/new-haven/us-ny/new-york',
    },
    {
        c2cId: 'NYC_CHI',
        urlSlug: '/train/us-ny/new-york/us-il/chicago',
    },
    {
        c2cId: 'NYC_ACY',
        urlSlug: '/train/us-ny/new-york/us-nj/atlantic-city',
    },
    {
        c2cId: 'SAN_LAX',
        urlSlug: '/train/us-ca/san-diego/us-ca/los-angeles',
    },
    {
        c2cId: 'DCA_NWK',
        urlSlug: '/bus/us-dc/washington/us-nj/newark',
    },
    {
        c2cId: 'NYC_CHI',
        urlSlug: '/bus/us-ny/new-york/us-il/chicago',
    },
    {
        c2cId: 'NYC_ORL',
        urlSlug: '/bus/us-ny/new-york/us-fl/orlando',
    },
    {
        c2cId: 'MKE_CHI',
        urlSlug: '/bus/us-wi/milwaukee/us-il/chicago',
    },
    {
        c2cId: 'NYC_BOS',
        urlSlug: '/bus/us-ny/new-york/us-ma/boston',
    },
    {
        c2cId: 'NYC_BOS',
        urlSlug: '/train/us-ny/new-york/us-ma/boston',
    },
    {
        c2cId: 'BOS_PHL',
        urlSlug: '/bus/us-ma/boston/us-pa/philadelphia',
    },
    {
        c2cId: 'RIC_NYC',
        urlSlug: '/train/us-va/richmond/us-ny/new-york',
    },
    {
        c2cId: 'SFO_LAX',
        urlSlug: '/bus/us-ca/san-francisco/us-ca/los-angeles',
    },
    {
        c2cId: 'LAX_LAS',
        urlSlug: '/bus/us-ca/los-angeles/us-nv/las-vegas',
    },
    {
        c2cId: 'BOS_POR',
        urlSlug: '/train/us-ma/boston/us-me/portland',
    },
    {
        c2cId: 'CHI_IND',
        urlSlug: '/train/us-il/chicago/us-in/indianapolis',
    },
    {
        c2cId: 'CHM_CHI',
        urlSlug: '/train/us-il/champaign/us-il/chicago',
    },
    {
        c2cId: 'NYC_CATOR',
        urlSlug: '/bus/us-ny/new-york/ca-on/toronto',
    },
    {
        c2cId: 'CATOR_NYC',
        urlSlug: '/bus/ca-on/toronto/us-ny/new-york',
    },
    {
        c2cId: 'PHL_DCA',
        urlSlug: '/bus/us-pa/philadelphia/us-dc/washington',
    },
    {
        c2cId: 'DCA_RIC',
        urlSlug: '/bus/us-dc/washington/us-va/richmond',
    },
    {
        c2cId: 'HAR_NYC',
        urlSlug: '/bus/us-pa/harrisburg/us-ny/new-york',
    },
    {
        c2cId: 'NYC_LAX',
        urlSlug: '/bus/us-ny/new-york/us-ca/los-angeles',
    },
    {
        c2cId: 'MIA_ORL',
        urlSlug: '/train/us-fl/miami/us-fl/orlando',
    },
    {
        c2cId: 'NYC_LAX',
        urlSlug: '/train/us-ny/new-york/us-ca/los-angeles',
    },
    {
        c2cId: 'NYC_CAMTL',
        urlSlug: '/train/us-ny/new-york/ca-qc/montreal',
    },
    {
        c2cId: 'NYC_HFD',
        urlSlug: '/train/us-ny/new-york/us-ct/hartford',
    },
    {
        c2cId: 'PDX_SEA',
        urlSlug: '/train/us-or/portland/us-wa/seattle',
    },
    {
        c2cId: 'DEBRL_DEMUN',
        urlSlug: '/train/de-be/berlin/de-by/munich',
    },
    {
        c2cId: 'BOS_NWK',
        urlSlug: '/bus/us-ma/boston/us-nj/newark',
    },
    {
        c2cId: 'CATOR_CAXDS',
        urlSlug: '/bus/ca-on/toronto/ca-on/ottawa',
    },
    {
        c2cId: 'SYR_NYC',
        urlSlug: '/bus/us-ny/syracuse/us-ny/new-york',
    },
    {
        c2cId: 'BNY_NYC',
        urlSlug: '/bus/us-ny/buffalo/us-ny/new-york',
    },
    {
        c2cId: 'PHL_DCA',
        urlSlug: '/train/us-pa/philadelphia/us-dc/washington',
    },
    {
        c2cId: 'LAX_SFO',
        urlSlug: '/train/us-ca/los-angeles/us-ca/san-francisco',
    },
    {
        c2cId: 'CHI_CHM',
        urlSlug: '/bus/us-il/chicago/us-il/champaign',
    },
    {
        c2cId: 'DAL_HOU',
        urlSlug: '/bus/us-tx/dallas/us-tx/houston',
    },
    {
        c2cId: 'CHI_NYC',
        urlSlug: '/bus/us-il/chicago/us-ny/new-york',
    },
    {
        c2cId: 'BAL_DCA',
        urlSlug: '/train/us-md/baltimore/us-dc/washington',
    },
    {
        c2cId: 'NWK_BOS',
        urlSlug: '/train/us-nj/newark/us-ma/boston',
    },
    {
        c2cId: 'SEA_CAVAC',
        urlSlug: '/train/us-wa/seattle/ca-bc/vancouver',
    },
    {
        c2cId: 'BOS_DCA',
        urlSlug: '/train/us-ma/boston/us-dc/washington',
    },
    {
        c2cId: 'BOS_POR',
        urlSlug: '/bus/us-ma/boston/us-me/portland',
    },
    {
        c2cId: 'DCA_NWK',
        urlSlug: '/train/us-dc/washington/us-nj/newark',
    },
    {
        c2cId: 'LAX_LAS',
        urlSlug: '/train/us-ca/los-angeles/us-nv/las-vegas',
    },
    {
        c2cId: 'NYC_ATL',
        urlSlug: '/bus/us-ny/new-york/us-ga/atlanta',
    },
    {
        c2cId: 'SAN_LAX',
        urlSlug: '/bus/us-ca/san-diego/us-ca/los-angeles',
    },
    {
        c2cId: 'NYC_PHL',
        urlSlug: '/train/us-ny/new-york/us-pa/philadelphia',
    },
    {
        c2cId: 'DCA_PHL',
        urlSlug: '/bus/us-dc/washington/us-pa/philadelphia',
    },
    {
        c2cId: 'ATL_NYC',
        urlSlug: '/bus/us-ga/atlanta/us-ny/new-york',
    },
    {
        c2cId: 'CAMTL_CATOR',
        urlSlug: '/bus/ca-qc/montreal/ca-on/toronto',
    },
    {
        c2cId: 'LAX_NYC',
        urlSlug: '/bus/us-ca/los-angeles/us-ny/new-york',
    },
    {
        c2cId: 'LAS_LAX',
        urlSlug: '/train/us-nv/las-vegas/us-ca/los-angeles',
    },
    {
        c2cId: 'NYC_BAL',
        urlSlug: '/train/us-ny/new-york/us-md/baltimore',
    },
    {
        c2cId: 'ORL_NYC',
        urlSlug: '/train/us-fl/orlando/us-ny/new-york',
    },
    {
        c2cId: 'STL_CHI',
        urlSlug: '/train/us-mo/st-louis/us-il/chicago',
    },
    {
        c2cId: 'TPA_MIA',
        urlSlug: '/train/us-fl/tampa/us-fl/miami',
    },
    {
        c2cId: 'CATOR_CAXLJ',
        urlSlug: '/train/ca-on/toronto/ca-qc/quebec-city',
    },
    {
        c2cId: 'PDX_SEA',
        urlSlug: '/bus/us-or/portland/us-wa/seattle',
    },
    {
        c2cId: 'NYC_PHL',
        urlSlug: '/bus/us-ny/new-york/us-pa/philadelphia',
    },
    {
        c2cId: 'RIC_DCA',
        urlSlug: '/bus/us-va/richmond/us-dc/washington',
    },
    {
        c2cId: 'NYC_ATL',
        urlSlug: '/train/us-ny/new-york/us-ga/atlanta',
    },
    {
        c2cId: 'DCA_PHL',
        urlSlug: '/train/us-dc/washington/us-pa/philadelphia',
    },
    {
        c2cId: 'BAL_NYC',
        urlSlug: '/bus/us-md/baltimore/us-ny/new-york',
    },
    {
        c2cId: 'LAX_SAN',
        urlSlug: '/bus/us-ca/los-angeles/us-ca/san-diego',
    },
    {
        c2cId: 'CHI_CHM',
        urlSlug: '/train/us-il/chicago/us-il/champaign',
    },
    {
        c2cId: 'CHI_LAX',
        urlSlug: '/train/us-il/chicago/us-ca/los-angeles',
    },
    {
        c2cId: 'NYC_ITH',
        urlSlug: '/bus/us-ny/new-york/us-ny/ithaca',
    },
    {
        c2cId: 'BOS_NYC',
        urlSlug: '/train/us-ma/boston/us-ny/new-york',
    },
    {
        c2cId: 'DCA_BOS',
        urlSlug: '/train/us-dc/washington/us-ma/boston',
    },
    {
        c2cId: 'NYC_CAMTL',
        urlSlug: '/bus/us-ny/new-york/ca-qc/montreal',
    },
    {
        c2cId: 'HAR_NYC',
        urlSlug: '/train/us-pa/harrisburg/us-ny/new-york',
    },
    {
        c2cId: 'CATOR_CAXDS',
        urlSlug: '/train/ca-on/toronto/ca-on/ottawa',
    },
    {
        c2cId: 'DAL_HOU',
        urlSlug: '/train/us-tx/dallas/us-tx/houston',
    },
    {
        c2cId: 'NYC_PGH',
        urlSlug: '/train/us-ny/new-york/us-pa/pittsburgh',
    },
    {
        c2cId: 'CAXLJ_CAMTL',
        urlSlug: '/bus/ca-qc/quebec-city/ca-qc/montreal',
    },
    {
        c2cId: 'CAMTL_CAXLJ',
        urlSlug: '/bus/ca-qc/montreal/ca-qc/quebec-city',
    },
    {
        c2cId: 'NYC_ITH',
        urlSlug: '/train/us-ny/new-york/us-ny/ithaca',
    },
    {
        c2cId: 'FLL_ORL',
        urlSlug: '/bus/us-fl/fort-lauderdale/us-fl/orlando',
    },
    {
        c2cId: 'HFD_NYC',
        urlSlug: '/bus/us-ct/hartford/us-ny/new-york',
    },
    {
        c2cId: 'MIA_ORL',
        urlSlug: '/bus/us-fl/miami/us-fl/orlando',
    },
    {
        c2cId: 'BOS_NHV',
        urlSlug: '/bus/us-ma/boston/us-ct/new-haven',
    },
    {
        c2cId: 'ATL_NYC',
        urlSlug: '/train/us-ga/atlanta/us-ny/new-york',
    },
    {
        c2cId: 'BOS_NWK',
        urlSlug: '/train/us-ma/boston/us-nj/newark',
    },
    {
        c2cId: 'NYC_DCA',
        urlSlug: '/train/us-ny/new-york/us-dc/washington',
    },
    {
        c2cId: 'BOS_NHV',
        urlSlug: '/train/us-ma/boston/us-ct/new-haven',
    },
    {
        c2cId: 'HFD_BOS',
        urlSlug: '/train/us-ct/hartford/us-ma/boston',
    },
    {
        c2cId: 'HFD_NYC',
        urlSlug: '/train/us-ct/hartford/us-ny/new-york',
    },
    {
        c2cId: 'KCY_CHI',
        urlSlug: '/train/us-mo/kansas-city/us-il/chicago',
    },
    {
        c2cId: 'LAX_SFO',
        urlSlug: '/bus/us-ca/los-angeles/us-ca/san-francisco',
    },
    {
        c2cId: 'NYC_BAL',
        urlSlug: '/bus/us-ny/new-york/us-md/baltimore',
    },
    {
        c2cId: 'RGH_NYC',
        urlSlug: '/bus/us-nc/raleigh/us-ny/new-york',
    },
    {
        c2cId: 'RIC_NYC',
        urlSlug: '/bus/us-va/richmond/us-ny/new-york',
    },
    {
        c2cId: 'NYC_CATOR',
        urlSlug: '/train/us-ny/new-york/ca-on/toronto',
    },
    {
        c2cId: 'ORL_MIA',
        urlSlug: '/train/us-fl/orlando/us-fl/miami',
    },
    {
        c2cId: 'CAMTL_NYC',
        urlSlug: '/bus/ca-qc/montreal/us-ny/new-york',
    },
    {
        c2cId: 'DEBRL_DEMUN',
        urlSlug: '/bus/de-be/berlin/de-by/munich',
    },
    {
        c2cId: 'ARB_CHI',
        urlSlug: '/bus/us-mi/ann-arbor/us-il/chicago',
    },
    {
        c2cId: 'CATOR_NYC',
        urlSlug: '/train/ca-on/toronto/us-ny/new-york',
    },
    {
        c2cId: 'DCA_BOS',
        urlSlug: '/bus/us-dc/washington/us-ma/boston',
    },
    {
        c2cId: 'MIA_NYC',
        urlSlug: '/train/us-fl/miami/us-ny/new-york',
    },
    {
        c2cId: 'PHL_NYC',
        urlSlug: '/train/us-pa/philadelphia/us-ny/new-york',
    },
    {
        c2cId: 'RGH_NYC',
        urlSlug: '/train/us-nc/raleigh/us-ny/new-york',
    },
    {
        c2cId: 'BOS_PVD',
        urlSlug: '/bus/us-ma/boston/us-ri/providence',
    },
    {
        c2cId: 'CAMTL_CAXLJ',
        urlSlug: '/train/ca-qc/montreal/ca-qc/quebec-city',
    },
    {
        c2cId: 'CAXLJ_CAMTL',
        urlSlug: '/train/ca-qc/quebec-city/ca-qc/montreal',
    },
    {
        c2cId: 'NYC_DCA',
        urlSlug: '/bus/us-ny/new-york/us-dc/washington',
    },
    {
        c2cId: 'LAS_LAX',
        urlSlug: '/bus/us-nv/las-vegas/us-ca/los-angeles',
    },
    {
        c2cId: 'BOS_NYC',
        urlSlug: '/bus/us-ma/boston/us-ny/new-york',
    },
    {
        c2cId: 'NWK_DCA',
        urlSlug: '/train/us-nj/newark/us-dc/washington',
    },
    {
        c2cId: 'ORL_MIA',
        urlSlug: '/bus/us-fl/orlando/us-fl/miami',
    },
    {
        c2cId: 'TPA_MIA',
        urlSlug: '/bus/us-fl/tampa/us-fl/miami',
    },
    {
        c2cId: 'NYC_ALB',
        urlSlug: '/bus/us-ny/new-york/us-ny/albany',
    },
    {
        c2cId: 'CATOR_CAVAC',
        urlSlug: '/bus/ca-on/toronto/ca-bc/vancouver',
    },
    {
        c2cId: 'NYC_PVD',
        urlSlug: '/bus/us-ny/new-york/us-ri/providence',
    },
    {
        c2cId: 'LAX_SAN',
        urlSlug: '/train/us-ca/los-angeles/us-ca/san-diego',
    },
    {
        c2cId: 'BOS_PVD',
        urlSlug: '/train/us-ma/boston/us-ri/providence',
    },
    {
        c2cId: 'SEA_PDX',
        urlSlug: '/bus/us-wa/seattle/us-or/portland',
    },
    {
        c2cId: 'PGH_NYC',
        urlSlug: '/bus/us-pa/pittsburgh/us-ny/new-york',
    },
    {
        c2cId: 'NHV_NYC',
        urlSlug: '/train/us-ct/new-haven/us-ny/new-york',
    },
    {
        c2cId: 'NYC_BNY',
        urlSlug: '/train/us-ny/new-york/us-ny/buffalo',
    },
    {
        c2cId: 'SEA_LWA',
        urlSlug: '/bus/us-wa/seattle/us-wa/leavenworth',
    },
    {
        c2cId: 'SJC_LAX',
        urlSlug: '/train/us-ca/san-jose/us-ca/los-angeles',
    },
    {
        c2cId: 'BAL_DCA',
        urlSlug: '/bus/us-md/baltimore/us-dc/washington',
    },
    {
        c2cId: 'DCA_BAL',
        urlSlug: '/train/us-dc/washington/us-md/baltimore',
    },
    {
        c2cId: 'MKE_CHI',
        urlSlug: '/train/us-wi/milwaukee/us-il/chicago',
    },
    {
        c2cId: 'CAMTL_CATOR',
        urlSlug: '/train/ca-qc/montreal/ca-on/toronto',
    },
    {
        c2cId: 'NYC_ACY',
        urlSlug: '/bus/us-ny/new-york/us-nj/atlantic-city',
    },
];
